import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/kkm-server',
    name: RouteName.SettingsKkmServer,
    component: () => import('@/pages/Settings/KkmServer.vue'),
    meta: {
      permissions: [CRMPermission.KkmServer],
      breadcrumb: {
        label: 'KKM Server',
        parent: RouteName.Settings,
      },
    },
  },
]
